import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import LoaderService from "../../service/loader/alert_service";
import AlertService from "../../service/alert/alert_service";

export default class extends Controller {
  async downloadXLSX(e) {
    let removeHref = e.currentTarget.dataset.removeHref;
    const asyncMessage = e.currentTarget.dataset.asyncMessage;
    const initTitle = e.currentTarget.dataset.initTitle;
    const asyncTitle = e.currentTarget.dataset.asyncTitle;
    const asyncReportHref = e.currentTarget.dataset.asyncReportHref;
    const folderId = e.currentTarget.dataset.folderId;

    try {
      LoaderService.showLoader();
      if (asyncReportHref) {
        await this._downloadAndRemoveXlsxFile(asyncReportHref, removeHref);
        document.querySelectorAll(`.export-xlsx-${folderId}`).forEach((item) => {
          item.innerText = initTitle;
            const parentLink = item.closest("a");
            if (parentLink) {
              parentLink.removeAttribute("data-async-report-href");
            }
        });
        return;
      }

      const { data } = await axios(e.currentTarget.dataset.createHref);
      if (data.status === "done" && data.downloadUrl) {
        await this._downloadAndRemoveXlsxFile(
          data.downloadUrl,
          removeHref.replace("REPLACE_KEY", data.reportKey)
        );
      } else {
        AlertService.showAlert("#alertMessage", asyncMessage);
        document
          .querySelectorAll(`.export-xlsx-${folderId}`)
          .forEach((item) => {
            item.innerText = asyncTitle;
            const parentLink = item.closest("a");
            if (parentLink) {
              parentLink.classList.add("disabled");
            }
          });
      }
    } catch (error) {
      console.error("Generate report error", error);
    } finally {
      LoaderService.hideLoader();
    }
  }

  async _downloadAndRemoveXlsxFile(downloadUrl, removeUrl) {
    const fileResponse = await axios.get(downloadUrl, {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(fileResponse.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = downloadUrl.split("/").pop() || "report.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    await axios(removeUrl);
  }
}
